import * as React from "react";

const Info: React.FC = () => (
    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 4C3.5625 4 0 7.59375 0 12C0 16.4375 3.5625 20 8 20C12.4062 20 16 16.4375 16 12C16 7.59375 12.4062 4 8 4ZM8 18.5C4.40625 18.5 1.5 15.5938 1.5 12C1.5 8.4375 4.40625 5.5 8 5.5C11.5625 5.5 14.5 8.4375 14.5 12C14.5 15.5938 11.5625 18.5 8 18.5ZM9.25 14.5H8.75V11.75C8.75 11.3438 8.40625 11 8 11H7C6.5625 11 6.25 11.3438 6.25 11.75C6.25 12.1875 6.5625 12.5 7 12.5H7.25V14.5H6.75C6.3125 14.5 6 14.8438 6 15.25C6 15.6875 6.3125 16 6.75 16H9.25C9.65625 16 10 15.6875 10 15.25C10 14.8438 9.65625 14.5 9.25 14.5ZM8 10C8.53125 10 9 9.5625 9 9C9 8.46875 8.53125 8 8 8C7.4375 8 7 8.46875 7 9C7 9.5625 7.4375 10 8 10Z"
            fill="#428BF8"
        />
    </svg>
);

export default React.memo(Info);
